<div>
  <p-autoComplete class="autocomplete" #autoComplete [id]="id" [ngModel]="value" (ngModelChange)="onChange($event)"
    [disabled]="readOnly" [suggestions]="suggestions" (completeMethod)="completeMethod($event)" [field]="propLabel"
    [inputStyleClass]="styleClass" [placeholder]="placeholder" (onSelect)="selected.emit($event)"
    (onUnselect)="deselected.emit($event)" [forceSelection]="forceSelection" (onClear)="cleared.emit($event)"
    (onBlur)="blur.emit($event)">
  </p-autoComplete>
</div>
